// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: 'AIzaSyCXpjwolrs3r3x56iYWSO3qJOXaV5D441M',
    authDomain: 'webnnel-nextontop.firebaseapp.com',
    databaseURL: 'https://webnnel-nextontop.firebaseio.com',
    projectId: 'webnnel-nextontop',
    storageBucket: 'webnnel-nextontop.appspot.com',
    messagingSenderId: '328338004224'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts